import { Warning, WhatsApp } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
  Box,
  Link,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

export default function DialogCODShipment({ open, onConfirm }) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1.5}>
          <Box
            sx={{
              color: "error.main",
              width: 40,
              height: 40,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Warning />
          </Box>

          <Typography variant="h6" fontWeight={600}>
            {t("importantNotice")}
          </Typography>
        </Box>
      </DialogTitle>

      <Divider />

      <DialogContent>
        <Box p={2}>
          <Typography bgcolor="warning.light" mb={2} p={1.5} lineHeight={1.8}>
            {t("codShipment.description")}
          </Typography>

          <Typography fontWeight={600} mb={1}>
            {t("codShipment.companiesTitle")}
          </Typography>
          <Box component="ul" sx={{ pl: 4, mb: 2 }}>
            <li>
              <Typography>{t("codShipment.companiesItems.cr")}</Typography>
            </li>
            <li>
              <Typography>{t("codShipment.companiesItems.iban")}</Typography>
            </li>
            <li>
              <Typography>{t("codShipment.companiesItems.tax")}</Typography>
            </li>
            <li>
              <Typography>{t("codShipment.companiesItems.address")}</Typography>
            </li>
          </Box>

          <Typography fontWeight={600} mb={1}>
            {t("codShipment.individualsTitle")}
          </Typography>
          <Box component="ul" sx={{ pl: 4, mb: 2 }}>
            <li>
              <Typography>
                {t("codShipment.individualsItems.freelance")}
              </Typography>
            </li>
            <li>
              <Typography>{t("codShipment.individualsItems.iban")}</Typography>
            </li>
            <li>
              <Typography>
                {t("codShipment.individualsItems.address")}
              </Typography>
            </li>
          </Box>

          <Box display="flex" alignItems="center" gap={1}>
            <WhatsApp color="success" />
            <Typography>
              {t("codShipment.contactPrefix")}
              <Link
                href="https://wa.me/966597327471"
                target="_blank"
                underline="hover"
                color="success.main"
              >
                {t("codShipment.contactLink")}
              </Link>
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ p: 2 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={onConfirm}
          sx={{ textTransform: "none", px: 4 }}
        >
          {t("continue")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
